const types = {
  EMAIL: 'EMAIL',
  SENDER: 'SENDER',
};
export default types;
